import { render, staticRenderFns } from "./HeadPublic.vue?vue&type=template&id=2121b778&scoped=true"
import script from "./HeadPublic.vue?vue&type=script&lang=js"
export * from "./HeadPublic.vue?vue&type=script&lang=js"
import style0 from "./HeadPublic.vue?vue&type=style&index=0&id=2121b778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121b778",
  null
  
)

export default component.exports